import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { MessageCircle, Check, Sparkles } from 'lucide-react';
import ScrollReveal from './ScrollReveal';

const FixedPricing = () => {
  const whatsappNumber = '41784417112';

  const handleWhatsApp = (size) => {
    window.open(`https://wa.me/${whatsappNumber}?text=Hallo,%20ich%20interessiere%20mich%20für%20den%20Fixpreis%20für%20eine%20${size}m²%20Wohnung.`, '_blank');
  };

  const pricingPackages = [
    { id: 'pkg-30', size: 30, price: 990, popular: false },
    { id: 'pkg-40', size: 40, price: 1290, popular: false },
    { id: 'pkg-50', size: 50, price: 1590, popular: false },
    { id: 'pkg-60', size: 60, price: 1790, popular: true },
    { id: 'pkg-70', size: 70, price: 1990, popular: false },
    { id: 'pkg-80', size: 80, price: 2290, popular: true },
    { id: 'pkg-90', size: 90, price: 2490, popular: false },
    { id: 'pkg-100', size: 100, price: 2790, popular: false }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-black via-black to-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_70%,rgba(124,58,237,0.05),transparent_50%)]"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <ScrollReveal>
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-yellow-500/10 border border-yellow-500/20 rounded-full text-yellow-400 text-sm font-medium mb-4">
              Fixpreise
            </div>
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
              Fixpreise für Wohnungen
            </h2>
            <p className="text-xl text-slate-400 max-w-3xl mx-auto">
              Transparente Preise für leere Wohnungen beim Auszug
            </p>
          </div>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto mb-12">
          {pricingPackages.map((pkg) => (
            <ScrollReveal key={pkg.id} delay={pricingPackages.indexOf(pkg) * 0.05}>
              <Card
                className={`p-8 backdrop-blur-xl border-2 transition-all duration-500 cursor-pointer group relative overflow-hidden ${
                  pkg.popular
                    ? 'bg-gradient-to-br from-blue-500/20 via-purple-500/10 to-transparent border-blue-500/40 hover:border-blue-400/60 shadow-2xl shadow-blue-500/20'
                    : 'bg-gradient-to-br from-slate-800/30 to-transparent border-slate-700/50 hover:border-slate-600/60'
                } hover:scale-105 hover:-translate-y-2`}
              >
                {/* Popular Badge */}
                {pkg.popular && (
                  <div className="absolute top-4 right-4">
                    <div className="px-3 py-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full text-white text-xs font-bold flex items-center gap-1">
                      <Sparkles className="w-3 h-3" />
                      Beliebt
                    </div>
                  </div>
                )}

                {/* Animated Background */}
                <div className="absolute -top-20 -right-20 w-40 h-40 bg-blue-500/10 rounded-full blur-3xl group-hover:scale-150 transition-transform duration-700"></div>
                
                <div className="relative z-10">
                  <div className="text-center mb-6">
                    <div className="text-5xl font-bold text-white mb-2">
                      {pkg.size}m²
                    </div>
                    <div className="text-slate-400 text-sm">Wohnung</div>
                  </div>

                  <div className="text-center mb-6 py-6 border-y-2 border-slate-700/50">
                    <div className="text-sm text-slate-500 mb-2">ab</div>
                    <div className="text-4xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 text-transparent bg-clip-text">
                      CHF {pkg.price}
                    </div>
                  </div>

                  <Button
                    onClick={() => handleWhatsApp(pkg.size)}
                    className="w-full bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white transition-all duration-300 shadow-lg shadow-green-500/20 hover:shadow-green-500/40"
                  >
                    <MessageCircle className="w-4 h-4 mr-2" />
                    Anfragen
                  </Button>
                </div>
              </Card>
            </ScrollReveal>
          ))}
        </div>

        <ScrollReveal delay={0.5}>
          <Card className="p-8 bg-gradient-to-r from-slate-800/40 to-slate-700/40 border-l-4 border-slate-500 max-w-4xl mx-auto backdrop-blur-xl">
            <div className="flex gap-4">
              <Check className="w-7 h-7 text-slate-400 flex-shrink-0 mt-1" />
              <div>
                <p className="text-slate-300 text-lg leading-relaxed">
                  <strong className="text-white">Hinweis:</strong> Die Preise gelten als Richtpreise für Standardwohnungen bis ca. 2.60 m Raumhöhe. Treppenhäuser, starke Verschmutzungen, farbige Wände oder besondere Anforderungen werden separat berechnet.
                </p>
              </div>
            </div>
          </Card>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default FixedPricing;